export default function hasLocalStorage() {
    return "localStorage" in window && window["localStorage"] !== null;
}
